<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div class="d-flex ">
          <div class="perma-section-input pl-2">{{input}}</div>
          <div>
            <v-btn class="ex-remove-btn w-100 ma-0 mb-2" @click="remove()" color="error" dark large>Remove Chain</v-btn>
            <div class="perma-section text-center pt-3 pb-3">{{method}}</div>
              <div class="page selector_chainlink" v-if="methods.expression.length > 0">
                <div class="chin-edit">
                  <v-btn
                    text
                    class="m-w chin-edit-icon"
                    @click="showExpressionDialog()"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </div>
                <div class="i-v-input">
                  <div>Expression Block</div>
                </div>
              </div>
              <div class="col" v-show="result.length > 0">{{result}}</div>
            <v-btn class="ex-add-btn  w-100 ma-0 mt-2" @click="add()" color="success" dark large>Add Chain</v-btn>
          </div>
          <div class="perma-section-output pr-2">{{output}}</div>
        </div>
      </v-flex>
    </v-layout>
    <!--    Dialog -->
    <v-dialog
      v-model="showExpressionBlock"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline"
          dark-title
        >
          Expression
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mb-3">
          <ex-card disable-offsets >
            <template slot="header" >
              <div v-show="output == 'expression'" class="page selector_chainlink">
                <div class="label mb-3">Result Selection</div>
                <v-select
                  v-model="variable.selected"
                  :items="variable.options"
                  solo
                ></v-select>
                <div v-show="variable.selected !== 'variable'">
                  <v-text-field
                    v-model="variable.text" placeholder="result"/>
                </div>
                <div v-show="variable.selected === 'Pass'">
                  continue
                </div>
              </div>
              <div class="expression-item"  v-for="(data, idx) in methods.expression" :key=idx>
                <v-btn v-show="idx !== 0" @click="removeExpression(idx)">Remove</v-btn>
                <v-checkbox
                  v-model="data.compare.instantreturn"
                  label="Instant return"
                ></v-checkbox>
                <div v-show="!data.compare.instantreturn">
                  <div>
                    <div class="label mb-3">Condition</div>
                    <v-select
                      v-model="data.condition.selected"
                      :items="data.condition.options"
                      solo
                    ></v-select>
                    <div class="label mb-3">Target:</div>
                    <v-select
                      v-model="data.target.selected"
                      :items="data.target.options"
                      solo
                    ></v-select>
                  </div>
                  <div>
                    <div v-show="data.target.selected === 'variable'">
                      <v-select
                        v-model="data.target.variable.selected"
                        :items="variables"
                        item-text="id"
                        item-value="id"
                        solo
                      ></v-select>
                    </div>
                    <div v-show="data.target.selected === 'prevResult'">
                      Previous result
                    </div>
                  </div>
                  <div>
                    <div v-show="data.target.selected != ''">
                      <div class="label mb-3">Expression Selection</div>
                      <v-select
                        v-model="data.expression.selected"
                        :items="data.expression.options"
                        solo
                      ></v-select>
                    </div>
                  </div>
                  <div v-show="showComparisonBox(data)">
                    <div v-show="data.target.selected != ''">
                      <div class="label mb-3">Comparison Selection</div>
                      <v-select
                        v-model="data.compare.selected"
                        :items="data.compare.options"
                        solo
                      ></v-select>
                      <v-select
                        v-show="data.compare.selected === 'variable'"
                        v-model="data.compare.variable.selected"
                        :items="variables"
                        item-text="id"
                        item-value="id"
                        solo
                      ></v-select>
                      <div v-show="data.compare.selected != 'variable'">
                        <v-btn v-show="data.compare.variable.selected != ''" @click="addVariableResult(data)">Add selected variable</v-btn>
                        <v-text-field v-model="data.compare.text" placeholder="Compare object"/>
                        <v-text-field v-model="data.compare.output" placeholder="Output value"/>
                        <v-select
                          v-show="data.compare.selected === 'date'"
                          v-model="data.compare.date.selected"
                          :items="data.compare.date.options"
                          solo
                        ></v-select>
                      </div>
                    </div>
                  </div>
                  <div>
                    Extend using
                    <v-select @change="moreExpression()"
                              v-model="data.extend.selected"
                              :items="['or', 'and', true, false]"
                              solo
                    ></v-select>
                  </div>
                </div>
                <v-text-field v-show="data.compare.instantreturn" v-model="data.compare.output" placeholder="Output value"/>
              </div>
            </template>
          </ex-card>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import {AppUrl} from '../../assets/js/variables'
import JwtService from '@/assets/js/JwtService'
export default {
  name: 'Expression',
  props: ['x', 'y', 'variables'],
  data: () => ({
    showExpressionBlock: false,
    destroy: false,
    result: '',
    variable: {options: [], selected: '', variable: {selected: ''}, text: '', extend: {selected: ''}},
    input: '',
    method: 'expression',
    output: 'expression',
    methods: {
      expression: []
    },
    options: {
      extend: {selected: ''},
      result: {options: [], selected: '', variable: {selected: ''}, text: '', extend: {selected: ''}},
      target: {options: [], selected: '', variable: {selected: ''}},
      compare: {instantreturn: false, options: [], selected: '', variable: {selected: ''}, text: '', date: {options: ['days', 'weeks', 'months'], selected: 'days'}, output: ''},
      condition: {options: [], selected: ''},
      expression: {options: [], selected: ''}
    }
  }),
  methods: {
    showExpressionDialog () {
      this.showExpressionBlock = true
    },
    addGlobalVars () {},
    addVariableResult (data) {
      data.compare.text += ':::::' + data.compare.variable.selected + ':::::'
    },
    moreExpression () {
      this.methods.expression.push(JSON.parse(JSON.stringify(this.options)))
    },
    removeExpression (idx) {
      if (idx !== 0) {
        this.methods.expression[idx - 1].result.extend.selected = ''
      }
      this.methods.expression.splice(idx, 1)
    },
    add () {
      this.$emit('add', this.y, this.x)
    },
    showComparisonBox: function (elem) {
      if (['greater', 'less', 'equal'].includes(elem.expression.selected)) {
        return true
      }
      return false
    },
    loadOptions () {
      const params = {headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
      const self = this
      axios.post(AppUrl, {
        task: 'getOptions',
        payload: {
          'chain': 'expression'
        }
      }, params).then(function (response) {
        var data = response.data
        self.$set(self.variable, 'options', data.outputs.result)
        self.$set(self.options.target, 'options', data.outputs.target)
        self.$set(self.options.condition, 'options', data.outputs.condition)
        self.$set(self.options.expression, 'options', data.outputs.expression)
        self.$set(self.options.compare, 'options', data.outputs.compare)
        console.log(self.methods.expression.length)
        if (self.methods.expression.length === 0) {
          self.$nextTick().then(() => {
            self.moreExpression()
          })
        }
      })
    },
    remove () {
      this.$emit('remove', this.y, this.x)
    }
  },
  created: function () {
    this.loadOptions()
  },
  mounted: function () {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/selector/Expression.vue